module.exports = __webpack_public_path__ + "static/media/corporate-img.2e55b470.png";